import { Joyride, STATUS, EVENTS, Step } from "react-joyride";
import { useEffect, useState, useMemo } from "react";

interface AppTourProps {
  filesCount?: number;
}

const TOUR_STORAGE_KEY = "has_completed_app_tour";

export default function AppTour({ filesCount = 0 }: AppTourProps) {
  const [run, setRun] = useState(false);

  useEffect(() => {
    const hasSeenTour = localStorage.getItem(TOUR_STORAGE_KEY);

    if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setRun(true);
      }, 600);

      return () => clearTimeout(timer);
    }
  }, []);

  const steps: Step[] = useMemo(() => {
    const baseSteps: Step[] = [
      {
        target: "#financial",
        content: "از این بخش می‌توانید به جزئیات مالی خود دسترسی داشته باشید",
        placement: "bottom",
      },
      {
        target: "#usageDetails",
        content:
          "با زدن این لینک می‌توانید جزئیات ریزمصرف خود را مشاهده بفرمایید",
        placement: "bottom",
      },
      {
        target: "#id-nav-post-btn",
        content: "خرید آی پی خود را می‌توانید از طریق لینک انجام دهید",
        placement: "bottom",
      },
    ];

    if (filesCount > 1) {
      baseSteps.push({
        target: "#tour-file-select",
        content:
          "از این منو می‌توانید بین پرونده‌ها یا فایل‌های مختلف جابجا شوید",
        placement: "bottom",
      });
    }

    baseSteps.push(
      {
        target: "#btn-burger",
        content: "ساید بار راباز کنید",
        placement: "left",
      },
      {
        target: "#id-user-info",
        content:
          "با بازکردن این بخش می‌توانید به بخش تنظیمات و تیکت‌های خود دسترسی داشته باشید",
        placement: "left",
      },
      {
        target: "#settings",
        content: "با زدن این بخش می‌توانید اطلاعات هویتی خود را ویرایش کنید",
        placement: "left",
      }
    );

    return baseSteps;
  }, [filesCount]);

  const handleJoyrideCallback = (data: any) => {
    const { status, type, step } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      localStorage.setItem(TOUR_STORAGE_KEY, "true");
      return;
    }

    if (type === EVENTS.STEP_BEFORE) {
      if (step?.target === "#id-user-info") {
        window.dispatchEvent(new CustomEvent("open-sidebar-tour"));
      }

      if (step?.target === "#settings") {
        window.dispatchEvent(new CustomEvent("open-sidebar-tour"));
        window.dispatchEvent(new CustomEvent("open-profile-menu-tour"));
      }
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      scrollToFirstStep={true}
      onEvent={handleJoyrideCallback} 
      locale={{
        back: "قبلی",
        close: "بستن",
        last: "پایان",
        next: "بعدی",
        skip: "رد کردن",
      }}
      styles={{
        tooltip: {
          zIndex: 9999,
        },
      }}
    />
  );
}
